import { useState, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import CachedIcon from '@mui/icons-material/Cached'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { Card } from '@mui/material'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import { constants as cons } from '../../Constants/constants'
import { getOne, put, post } from '../../helper/baseFetch'
import { setQueueChannelFn, setQueueChannelFnValue, setQueueChannelFnResourcesStepsValue } from '../../actions/queueChannelFnAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempBtn } from '../../Component/Input/TempBtn'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { getString, helperTextStyles } from '../../helper/util'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { ResourcesSteps } from './ResourcesSteps'
import { ResetDialog } from './ResetDialog'
import { CounterProfileSelectField } from './CounterProfileSelectField'
import useRestaurant from '../../hooks/Restaurant/useRestaurant'
import { BOOLEAN_OPTIONS } from '../../Constants/type'
import { Clear } from '@mui/icons-material'
import { getContent } from '../../Component/EditCreateDisplay/EditUtil'

const FNS = {
  delele: 'DELETE',
  guest: 'GUEST',
  readonly: 'READ_ONLY',
  share: 'SHARE',
  vip: 'VIP',
}

export const QueueChannelFnEdit = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()
  const params = useParams()
  const [ready, setReady] = useState(false)
  const [clear, setClear] = useState(true)
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })

  const defaultError = { transferable: '', checkOutType: '', maxTicketPerSection: '', limitTicketInMinute: '' }
  const [error, setError] = useState(defaultError)
  const helperTextStylesClasses = helperTextStyles()
  const [resetDialogOpen, setResetDialogOpen] = useState(false)
  const resource = 'QueueChannelFn'
  const savedQueueChannelFn = useSelector((state) => state.queueChannelFn.ui.queueChannelFn)
  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)
  const { getRestaurantIdAndName } = useRestaurant(params.id)

  const fields = [
    (channelData) => ({
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: channelData?.function },
      className: 'sub-title',
      function: channelData?.function
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'kiosk' },
      value: channelData?.kiosk,
      type: cons.TYPE.CHECKBOX,
      name: 'kiosk',
      size: cons.SIZE.SMALL,
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'line' },
      value: channelData?.line,
      type: cons.TYPE.CHECKBOX,
      name: 'line',
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'mobile' },
      value: channelData?.mobile,
      name: 'mobile',
      type: cons.TYPE.CHECKBOX,
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'pr' },
      value: channelData?.pr,
      name: 'pr',
      type: cons.TYPE.CHECKBOX,
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'web' },
      value: channelData?.web,
      name: 'web',
      type: cons.TYPE.CHECKBOX,
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'webExternal' },
      value: channelData?.webExternal,
      name: 'webExternal',
      type: cons.TYPE.CHECKBOX,
      isEndOfLine: false,
    }),
    channelData => ({
      className: 'edit-create-input edit-display-wrapper',
      function: channelData?.function,
      label: { resource: resource, key: 'wechatMp' },
      value: channelData?.wechatMp,
      name: 'wechatMp',
      type: cons.TYPE.CHECKBOX,
      isEndOfLine: false,
    }),
  ]
  const content = [
    {
      tab: savedQueueChannelFn?.map(channel => (
        fields.map((inputSetting, index) => {
          // NOTICE: onSelectCheckbox only handle checkbox, need to pass new handle when there are other types
          let content = getContent(inputSetting(channel), index, onSelectCheckbox)
          return (
            <div className="edit-display-wrapper" key={index}>
              {content}
              {inputSetting(channel).isEndOfLine && <div></div>}
            </div>
          )
        })
      )),
      btn: true,
    },
  ]

  const bottomBtns = [
    {
      variant: cons.STYLE.VARIANT.CONTAINED,
      color: cons.STYLE.PRIMARY,
      label: { key: 'save' },
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    {
      variant: cons.STYLE.VARIANT.CONTAINED,
      color: cons.STYLE.PRIMARY,
      label: { key: 'clear' },
      disabled: false,
      onClick: () => setClear(true),
      className: 'margin-left-16',
      icon: <ClearIcon />,
    }
  ]

  const onClickBackToEdit = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    setClear(true)
  }

  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push('/' + cons.PATH.SHOP.SYSTEM_GROUP_RESTAURANT)
  }

  const setUnlimitedQuota = (name) => {
    onChangeInput(name, null)
  }

  const setNull = (name) => {
    dispatch(setQueueChannelFnValue(name, savedQueueChannelFn, '', null))
  }

  function onDragEnd(result) {
    if (!result.destination) return
    let newQueueSteps = _.cloneDeep(savedQueueChannelFn.queueSteps)
    const [reorderedItem] = newQueueSteps.splice(result.source.index, 1)
    newQueueSteps.splice(result.destination.index, 0, reorderedItem)
    dispatch(setQueueChannelFnValue('queueSteps', savedQueueChannelFn, '', newQueueSteps))
  }

  function addQueueSteps() {
    let newQueueSteps = _.cloneDeep(savedQueueChannelFn.queueSteps)
    newQueueSteps && newQueueSteps.length > 0 ? newQueueSteps.push('') : (newQueueSteps = [''])
    dispatch(setQueueChannelFnValue('queueSteps', savedQueueChannelFn, '', newQueueSteps))
  }

  function removeQueueSteps(idx) {
    let newQueueSteps = _.cloneDeep(savedQueueChannelFn.queueSteps)
    if (newQueueSteps && newQueueSteps.length > 0) {
      newQueueSteps = newQueueSteps.filter((item, newQueueStepsIndex) => newQueueStepsIndex !== idx)
    }
    dispatch(setQueueChannelFnValue('queueSteps', savedQueueChannelFn, '', newQueueSteps))
  }

  function validate(savedQueueConfig) {
    let newError = { ...error }

    if (
      (Number.isInteger(savedQueueConfig.limitTicketInMinute) && Number.isInteger(savedQueueConfig.maxTicketPerSection)) ||
      (savedQueueConfig.limitTicketInMinute === null && savedQueueConfig.maxTicketPerSection === null)
    ) {
      newError.maxTicketPerSection = ''
      newError.limitTicketInMinute = ''
    } else {
      newError.maxTicketPerSection = 'Both Max Ticket Per Section and Limit Ticket In Minute should be integer or empty.'
      newError.limitTicketInMinute = 'Both Max Ticket Per Section and Limit Ticket In Minute should be integer or empty.'
    }

    if (savedQueueConfig.transferable && savedQueueConfig.checkOutType === 'NONE') {
      newError.transferable = 'Check Out Type Should Not be NONE if transferrable is true'
      newError.checkOutType = 'Check Out Type Should Not be NONE if transferrable is true'
    } else {
      newError.transferable = ''
      newError.checkOutType = ''
    }

    setError(newError)
  }

  function onChangeInput(name, e, idx, dataList) {
    let newSavedQueueChannelFn = _.cloneDeep(savedQueueChannelFn)

    newSavedQueueChannelFn?.map(channel => {
      if (channel?.function === dataList?.function) {
        channel[name] = e
      }
    })

    dispatch(setQueueChannelFn(newSavedQueueChannelFn))
  }

  function onSelectCheckbox(name, e, idx, dataList) {
    onChangeInput(name, !e, idx, dataList)
  }

  function onClickClearDialog() {
    setResetDialogOpen(true)
  }

  function onClickReset() {
    put(
      cons.PATH.SHOP.QUEUE.RESET_CURRENT_TIME_SECTION + '/' + params.id,
      undefined,
      () => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: 'resetSuccess' },
          dialogActions: [
            { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      undefined,
      store
    )
  }

  function onClickSave() {
    let newSavedQueueConfig = _.cloneDeep(savedQueueChannelFn)

    if (Object.values(error).some((value) => value)) {
      return
    }

    setError(defaultError)

    put(
      cons.PATH.SHOP.QUEUE.QUEUE_CHANNEL_FN + '/' + params.id,
      newSavedQueueConfig,
      () => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: 'editSuccess' },
          dialogActions: [
            { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      undefined,
      store
    )
  }

  useEffect(() => {
    if (clear === true) {
      setError(defaultError)
      getOne(
        cons.PATH.SHOP.QUEUE.QUEUE_CHANNEL_FN + '/' + params.id,
        undefined,
        (payload) => {
          let newPayload = _.cloneDeep(payload)

          dispatch(setQueueChannelFn(newPayload))
          setReady(true)
          setClear(false)
        },
        undefined,
        store
      )
    }
  }, [clear]) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    ready && (
      <>
        <EditCreateDisplay
          code={params.id ? params.id : ''}
          resource={resource}
          tabs={false}
          content={content}
          onChangeInput={onChangeInput}
          bottomBtns={bottomBtns}
          display="none"
        />
        {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
        {resetDialogOpen && (
          <ResetDialog
            open={resetDialogOpen}
            setOpen={setResetDialogOpen}
            onClickReset={onClickReset}
            resetTimeStamp={savedQueueChannelFn.resetUpdateTimestamp}
            shopName={getRestaurantIdAndName(params.id)}
          />
        )}
      </>
    )
  )
}
